export enum StatisticInterval {
    day = 1,
    month = 2,
}
